"use client";
import SvgEvStationFilled from "./ev_station-filled.svg.js";
import SvgEvStationOutlined from "./ev_station-outlined.svg.js";
import SvgEvStationRound from "./ev_station-round.svg.js";
import SvgEvStationSharp from "./ev_station-sharp.svg.js";
import SvgForestFilled from "./forest-filled.svg.js";
import SvgForestOutlined from "./forest-outlined.svg.js";
import SvgForestRound from "./forest-round.svg.js";
import SvgForestSharp from "./forest-sharp.svg.js";
import SvgGasStationFilled from "./gas_station-filled.svg.js";
import SvgGasStationOutlined from "./gas_station-outlined.svg.js";
import SvgGasStationRound from "./gas_station-round.svg.js";
import SvgGasStationSharp from "./gas_station-sharp.svg.js";
import SvgLocationFilled from "./location-filled.svg.js";
import SvgLocationOutlined from "./location-outlined.svg.js";
import SvgLocationRound from "./location-round.svg.js";
import SvgLocationSharp from "./location-sharp.svg.js";
import SvgRouteFilled from "./route-filled.svg.js";
import SvgRouteOutlined from "./route-outlined.svg.js";
import SvgRouteRound from "./route-round.svg.js";
import SvgRouteSharp from "./route-sharp.svg.js";
const ev_station = {
  filled: SvgEvStationFilled,
  outlined: SvgEvStationOutlined,
  round: SvgEvStationRound,
  sharp: SvgEvStationSharp
};
const forest = {
  filled: SvgForestFilled,
  outlined: SvgForestOutlined,
  round: SvgForestRound,
  sharp: SvgForestSharp
};
const gas_station = {
  filled: SvgGasStationFilled,
  outlined: SvgGasStationOutlined,
  round: SvgGasStationRound,
  sharp: SvgGasStationSharp
};
const location = {
  filled: SvgLocationFilled,
  outlined: SvgLocationOutlined,
  round: SvgLocationRound,
  sharp: SvgLocationSharp
};
const route = {
  filled: SvgRouteFilled,
  outlined: SvgRouteOutlined,
  round: SvgRouteRound,
  sharp: SvgRouteSharp
};
export {
  ev_station,
  forest,
  gas_station,
  location,
  route
};
